import { AppButton } from "@libs/zapi-ui/custom";

type TCurrentStatusDropdownProps = {
  isCurrent: boolean;
  isDropdownOpen: boolean;
  setIsDropdownOpen: (open: boolean) => void;
  updateCurrent: (current: boolean) => void;
  isValidationAll: boolean;
};

export function CurrentStatusDropdown(props: TCurrentStatusDropdownProps) {
  const { isCurrent, isDropdownOpen, setIsDropdownOpen, updateCurrent, isValidationAll } = props;
  return (
    <div className="relative">
      <AppButton
        data-testid="current-status-toggle"
        appearance="text"
        size="sm"
        className="h-8 gap-1.5 px-4 transition-all duration-100"
        onClick={() => {
          if (isCurrent || isValidationAll) return;
          setIsDropdownOpen(!isDropdownOpen);
        }}
        disabled={isValidationAll}
      >
        <div className="h-2 w-2 rounded-[3px] bg-zinc-500" />
        <span className="text-[14px] text-zinc-900 font-medium">
          {isValidationAll ? "Processing" : isCurrent ? "Current" : "Stale"}
        </span>
      </AppButton>
      {isDropdownOpen && !isValidationAll && (
        <div className="absolute top-full left-0 mt-1 bg-white shadow-md rounded-md z-10">
          <AppButton
            data-testid="current-status-dropdown-current"
            appearance="text"
            size="sm"
            className="w-full text-left px-4 py-2 hover:bg-gray-100"
            onClick={() => {
              updateCurrent(true);
              setIsDropdownOpen(false);
            }}
          >
            Current
          </AppButton>
        </div>
      )}
    </div>
  );
}
